{{ this.valore == "-" ? this.valore : (this.valore | s1Currency) }}